import './yotpo-ugs.css';

export default (element) => {
  const init = () => {
    const yotpoContainer = element.querySelector('.yotpo-pictures-widget');
    
    function handleYotpoContainerChange (mutationsList, observer) {
      if (yotpoContainer.children.length > 0) {
        element.classList.remove('max-h-0');
        observer.disconnect();
      }
    };

    const observer = new MutationObserver(handleYotpoContainerChange);
    observer.observe(yotpoContainer, { childList: true });
  };

  init();
};